import React, { useState } from 'react';
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from "react-redux";
import { Link } from 'react-router-dom';
import { EcoPointsStarIcon, NextIcon } from '../../../assets/icons';
import MarketPlacehome from '../../../assets/img/Marketplace-morado.png';
import circle from '../../../assets/img/circulogris.png';
import EcobolsaBlanco from '../../../img/EcobolsaBlanco.png';
import style from './ShowCase.module.css'
import { Translate } from '../../../language';
import CardListProducts from '../../../utils/components/CardListProducts/CardListProducts';
import { Menu, MenuItem, Box, ThemeProvider } from "@material-ui/core"
import NestedMenuItem from "material-ui-nested-menu-item"
import "./ShowCase.css"
import useModal from '../../../utils/hooks/useModal';
import modalStyle from './ModalStyle.module.css'
import Input from '../../../utils/components/Input/Input';
import localStorage from '../../../utils/hooks/useLocalStorage';

const ShowCase = (
    {
        pointsBuy,
        ecoPrice,
        bestSellerProducts,
        consolidateProducts,
        setPage,
        categories,
        setSkipConsolidateProducts,
        pageSkip,
        pointsToRedeem,
        searchState,
        setSearchState,
        categoryState,
        setCategoryState,
        subCategoryState,
        setSubCategoryState
    }) => {
    const dispatch = useDispatch()

    const { userInfo } = useSelector(state => state.userInfo)
    const { bag } = useSelector(state => state.marketPlace)
    const history = useHistory()

    const [product, setProduct] = useState([]);
    const [ref, isShow, setIsShow] = useModal(false)

    const [searchMenuPosition, setSearchMenuPosition] = useState(null);

    const handleSearchClick = (event) => {
        console.log()
        setSearchMenuPosition(
            {
                top: event.currentTarget.getBoundingClientRect().top + 40,
                left: event.currentTarget.getBoundingClientRect().left
            }
        );
    }

    const handleSearchClose = () => {
        setSearchMenuPosition(null);
    }

    const handleCategory = (categoryId) => {
        setCategoryState(categoryId)
        setSubCategoryState('');
    }

    const handleSubCategory = (categoryId, subCategoryId) => {
        setCategoryState(categoryId);
        setSubCategoryState(subCategoryId);
    }



    return (
        <div className={`showCase-container`}
        >

            <div className='showCase-title-container'>
                <div className='showCase-icon-container'>
                    <img src={MarketPlacehome} height={30} />
                </div>

                <div className="showCase-title">{Translate('MarketPlace', 'es')}</div>
                <div className="showCase-shoppingBag"
                >

                    <div className="spreader-bar-navbar"></div>
                    <Input
                        type="text"
                        placeholder={'Buscar producto'}
                        name="searchInput"
                        value={searchState}
                        classNameInput={`width-200 text-center color-purple-dark ${style.search_button}`}
                        onChange={(e) => { setSearchState(e.target.value) }}
                    />
                    <div className="spreader-bar-navbar"></div>

                  
                        <NestedMenuItem

                            id="basic-button"
                            parentMenuOpen={Boolean(searchMenuPosition)}
                            label={"Categorías"}
                            onClick={handleSearchClick}
                            aria-controls={Boolean(searchMenuPosition) ? 'basic-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={Boolean(searchMenuPosition) ? 'true' : undefined}
                        />
                        <Menu
                            id="basic-menu"
                            anchorReference="anchorPosition"
                            anchorPosition={searchMenuPosition}
                            open={Boolean(searchMenuPosition)}
                            onClose={handleSearchClose}
                            MenuListProps={{
                                'aria-labelledby': 'basic-button',
                            }}

                        >


                            {

                                categories.map((category, index) => (
                                    <Box key={category._id} sx={{
                                        color: 'var(--tittle-color)',
                                    }}>
                                        <NestedMenuItem
                                            key={index}
                                            label={category.name}
                                            parentMenuOpen={Boolean(searchMenuPosition)}
                                            onClick={() => {
                                                handleCategory(category._id);
                                            }}
                                            value={category._id}
                                        >

                                            {
                                                category.subCategoriesIds?.map((subCategory, indexSubCategory) => (
                                                    <Box key={subCategory._id} sx={{
                                                        color: 'var(--tittle-color)'
                                                    }}>
                                                        <MenuItem
                                                            key={indexSubCategory}
                                                            onClick={() => { handleSubCategory(category._id, subCategory._id) }}
                                                        >
                                                            {subCategory.name}
                                                        </MenuItem>
                                                    </Box>
                                                ))
                                            }
                                        </NestedMenuItem>
                                    </Box>



                                ))
                            }

                            <Box sx={{
                                color: 'var(--secondary-color)',
                                fontSize: '0.9rem'

                            }}>
                                <MenuItem
                                    onClick={() => { handleSubCategory('', '') }}

                                >
                                    Limpiar filtro
                                </MenuItem>

                            </Box>

                        </Menu>
                   

                    <div className="spreader-bar-navbar"></div>


                    <Link className='link-style' to="/MarketPlace/Purchases">{Translate('myPurchases', 'es')}</Link>
                    <div className="spreader-bar-navbar"></div>
                    {
                        (localStorage().getItem("typeProfile") === "user" || localStorage().getItem("typeProfile") === "representative") && (
                            <>
                                <div className='link-style'>
                                    {pointsToRedeem?.ecoPoints ? pointsToRedeem?.ecoPoints : 0} Ecos para redimir
                                </div>
                                <div className="spreader-bar-navbar"></div>
                            </>
                        )}


                    {
                        localStorage().getItem("typeProfile") ==="franchise" && (
                            <>
                                <Link className='link-style' to="/MarketPlace/Points">{Translate('ecoPoints', 'es')}</Link>
                                <EcoPointsStarIcon height={37} />
                                <div className='link-style'>{pointsBuy}</div>

                                <div className="spreader-bar-navbar"></div>
                            </>
                        )
                    }

                    <Link className='link-style' to="/ShoppingBag">{Translate('Ecobolsa', 'es')}</Link>

                    <div className='shop-icon-container'><img className='icon-style' src={EcobolsaBlanco} /></div>
                    <div className="spreader-bar-navbar"></div>

                </div>
            </div>

            <div className={`${style.card_container}`}>
                {(!categoryState && !searchState) && <>
                    <div className={`${style.showcase_subtitle} margin-top-10vh`}>{Translate('BestSeller', 'es')}</div>
                    <div className={`${style.bestseller_content_grid}`}>
                        <div className='icon-container icon-container-left'
                            onClick={() => {
                                setPage(prev => {
                                    if (prev > 0) {
                                        return prev - 1;
                                    } else {
                                        return 0;
                                    }

                                })
                            }}>
                            <NextIcon className="cls-back-next back-svg" height="22" width="15" />
                        </div>
                        <div className={`${style.bestseller_content}`}>

                            {
                                bestSellerProducts.map( (product, index) => (
                                    <CardListProducts
                                        key={product._id}
                                        maxQuantity={product?.inventory?.stocks}
                                        productBag={bag.filter(item => item._id ===product._id)[0]} 
                                        product={product}
                                        pricePoints={product.price / ecoPrice}
                                        picture={product && product.image && product.image.url.origin}
                                        text={product.name}
                                        onClickPicture={() => {
                                            setProduct(product)
                                            setIsShow(true)

                                        }}
                                    />
                                ))
                            }
                        </div>
                        <div className='icon-container icon-container-right'
                            onClick={() => {
                                setPage(prev => {
                                    if (bestSellerProducts.length > 1) {
                                        return prev + 1;
                                    } else {
                                        return prev;
                                    }

                                })
                            }}>
                            <NextIcon className="cls-back-next" height="22" width="15" />
                        </div>
                    </div>
                </>
                }

                <div className='showCase-subTitle margin-top-10vh'>Conoce nuestros productos</div>
                <div className={`${style.product_content_grid}`}>

                    <div className={`${style.products_content}`}>

                        {
                            consolidateProducts.map(({ products, stocks, _id }, index) => (
                                <CardListProducts
                                    zIndex={50 - index}
                                    key={_id}
                                    maxQuantity={stocks}
                                    productBag={bag.filter(item => item._id ===products[0]._id)[0]}
                                    product={products[0]}
                                    pricePoints={products[0].price / ecoPrice}
                                    picture={products[0] && products[0].image && products[0].image.url.origin}
                                    text={products[0].name}
                                    onClickPicture={() => {
                                        setProduct(products[0])
                                        setIsShow(true)

                                    }}
                                />
                            ))
                        }
                    </div>
                </div>
                <div className={`${style.nav_button_container}`}>
                    <div className={`${style.nav_button}`}>
                        <NextIcon
                            className="cls-back-next back-svg"
                            height="22"
                            width="15"
                            onClick={() => {
                                setSkipConsolidateProducts(skipConsolidateProducts => {
                                    if (skipConsolidateProducts > pageSkip) {
                                        return skipConsolidateProducts - pageSkip;
                                    } else {
                                        return 0;
                                    }
                                })
                            }} />


                    </div>
                    <div className={`${style.nav_button}`}>
                        <NextIcon onClick={() => {
                            setSkipConsolidateProducts(skipConsolidateProducts => {
                                if (bestSellerProducts.length > pageSkip) {
                                    return skipConsolidateProducts + pageSkip;
                                } else {
                                    return skipConsolidateProducts;
                                }

                            })
                        }} className="cls-back-next" height="22" width="15" />
                    </div>
                </div>
                <div className={`${style.bottom_space}`}></div>

            </div>



            < Modal
                closeModal={() => { setIsShow(false) }}
                displayModal={isShow}
                modalStyle={modalStyle}
                circle={circle}
                product={product} />
        </div >
    )
};

const Modal = ({ closeModal, displayModal, modalStyle, product, circle }) => {
    const divStyle = {
        display: displayModal ? 'block' : 'none'
    }
    const close = (e) => {
        closeModal(e)
    }

    return <div
        className={`${modalStyle.background_container}`}
        style={divStyle}
        onClick={close}>
        <div
            className={`${modalStyle.modal_content}`}
        >
            <div className={`${modalStyle.product_name}`}>
                {product?.name}
            </div>
            <div className={`${modalStyle.information_content}`}>
                <div className={`${modalStyle.content_img}`}>
                    <img alt="img" className={`${modalStyle.img_product}`} onError={(e) =>
                        e.target.src = circle} src={product?.image?.url.origin}></img>
                </div>
                <div className={`${modalStyle.content_description}`}>
                    <div className={`${modalStyle.description_title}`}>
                        Descripción
                    </div>
                    <div className={`${modalStyle.description_text}`}>
                        {product?.description}
                    </div>

                    {product?.instructions && <div className='mt-3'><div className={`${modalStyle.description_title}`}>
                        Instrucciones de uso
                    </div>
                        <div className={`${modalStyle.description_text}`}>
                            {product.instructions}
                        </div>
                    </div>}

                    {product?.ingredients && <div className='mt-3'><div className={`${modalStyle.description_title}`}>
                        Ingredientes
                    </div>
                        <div className={`${modalStyle.description_text}`}>
                            {product.ingredients}
                        </div>
                    </div>}

                    {product?.productsize && <div className='mt-3'><div className={`${modalStyle.description_title}`}>
                        Tamaño
                    </div>
                        <div className={`${modalStyle.description_text}`}>
                            {product.productsize}
                        </div>
                    </div>}

                </div>
            </div>

        </div>
    </div>
}

export default ShowCase;